<template>
    <!-- 对话框 -->
    <el-drawer title="签约设置" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="800px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <div class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' : submit_data.job_type == 2 ? '兼职' : '按单' }}签约设置</div>

                <el-form
                    ref="form"
                    v-model="submit_data"
                    label-width="80px"
                    style="height: 90vh; overflow-y: auto"
                    class="driver-sign-form"
                >
                    <!-- 全职签约缴费方式 -->
                    <div v-if="submit_data.job_type == 1">
                        <el-form-item label="缴费方式:" label-width="120px">
                            <el-radio-group v-model="submit_data.pay_type">
                                <el-radio label="1">整月签约</el-radio>
                                <el-radio label="2">自然月签约</el-radio>
                               
                            </el-radio-group>
                        </el-form-item>
                        <!--  全职签约整月 -->
                        <div v-if="submit_data.pay_type == 1" class="day-fee">
                            <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">全职司机包月费</span>
                                <el-input
                                    v-model="submit_data.platform_service_fee"
                                    :placeholder="submit_rules.platform_service_fee.placeholder"
                                    class="input-style"
                                >
                                </el-input
                                >元
                            </el-form-item>
                            <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">签约规则: 整月签约固定为30天 (跨自然月)</span>
                            </el-form-item>
                        </div>
                        <!--  全职自然月 -->
                        <div v-if="submit_data.pay_type == 2">
                            <div class="day-fee">
                                <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' : submit_data.job_type == 2 ? '兼职' : '按单' }}司机包月费</span>
                                <el-input
                                    v-model="submit_data.platform_service_fee"
                                    :placeholder="submit_rules.platform_service_fee.placeholder"
                                    class="input-style"
                                >
                                </el-input
                                >元
                            </el-form-item>
                            <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' : submit_data.job_type == 2 ? '兼职' : '按单' }}天费</span>
                                <el-input v-model="submit_data.day_fee" :placeholder="submit_rules.day_fee.placeholder" class="input-style">
                                </el-input
                                >元
                            </el-form-item>

                            </div>
                            <el-form-item>
                                <!-- 加减号按钮 阶段缴费 -->
                                <div class="jt-border">
                                    <div>
                                        <span class="jd-span">阶段缴费：</span>
                                        <!-- 加减号按钮 -->
                                        <div class="jia-jian-btn">
                                            <el-button
                                                @click="addKiloTake(2)"
                                                type="success"
                                                class="jia-jian-btn1"
                                                icon="el-icon-plus"
                                            ></el-button>

                                            <el-button
                                                @click="subKiloTake(2)"
                                                type="danger"
                                                class="jia-jian-btn1"
                                                icon="el-icon-minus"
                                            ></el-button>
                                        </div>
                                    </div>

                                    <!-- 全职自然月阶段缴费 -->
                                    <div class="driver-naturl" v-for="(item, index) in natural_month_fee" :key="index">
                                        <div class="jt-input">
                                            <span>每月:</span>
                                            <el-input v-model="item.s" class = "jt-input-val"></el-input> 日
                                        </div>
                                        <div class="jt-input">
                                            <span>到:</span>
                                            <el-input v-model="item.e" class = "jt-input-val"></el-input> 日
                                        </div>
                                        <div class="jt-input">
                                            <span>缴纳:</span>
                                            <el-input v-model="item.f" class = "jt-input-val"></el-input> 元
                                        </div>
                                    </div>
                                    <div class = "jt-desc">不管每月最后一天是几号，填写31即为月末</div>
                                </div>
                            </el-form-item>
                            <el-form-item label="" label-width="10px" class="desc">
                                <div style="font-weight: 700">签约规则:</div>
                                <div>1.以自然月为单位，每个月第一天为签约第一天，月底最后一天签约结束</div>
                                <div>2.可配置多个时间段的签约金额，如约配置到月底，填写31，参考示例图中最后一行配置</div>
                                <div>3.未配置到月底的时间段部分按最后配置日期至月底的剩余天数*天费计算包月签约金额</div>
                                <div>4.不足整月按签约日至月底的天数*天费进行收取</div>
                                <div>5.若配置阶段缴费，则先取阶段缴费配置进行收费，未配置的日期部分按天费计算收取</div>
                                <div>
                                    <img src="../../../../assets/img/examples.png" alt="" />
                                </div>
                            </el-form-item>
                        </div>
                    </div>

                    <!-- 兼职签约缴费方式 -->
                    <div v-if="submit_data.job_type == 2">
                        <el-form-item label="缴费方式:" label-width="120px">
                            <el-radio-group v-model="submit_data.pay_type">
                                <el-radio label="2">自然月签约</el-radio>
                                <!-- <el-radio label="3">按天签约</el-radio> -->
                            </el-radio-group>
                        </el-form-item>
                        <!--  兼职签约按天 -->
                        <!-- <div v-if="submit_data.pay_type == 3">
                            <div class="day-fee">
                                <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' : '兼职' }}天费</span>
                                <el-input v-model="submit_data.day_fee" :placeholder="submit_rules.day_fee.placeholder" class="input-style">
                                </el-input
                                >元
                            </el-form-item>
                            <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">预付保险费（单）</span>
                                <el-input
                                    v-model="submit_data.driver_insurance_fee"
                                    :placeholder="submit_rules.driver_insurance_fee.placeholder"
                                    class="input-style"
                                >
                                </el-input
                                >元
                            </el-form-item>
                            </div>
                            
                            <el-form-item>
                            
                                <div class="jt-border">
                               
                                    <span class="jd-span">按天签约：</span>
                                   

                                    <div class="jia-jian-btn">
                                        <el-button
                                            @click="addKiloTake(1)"
                                            type="success"
                                            class="jia-jian-btn1"
                                            icon="el-icon-plus"
                                        ></el-button>

                                        <el-button
                                            @click="subKiloTake(1)"
                                            type="danger"
                                            class="jia-jian-btn1"
                                            icon="el-icon-minus"
                                        ></el-button>
                                    </div>
                               
                                    <div class="driver-naturl" v-for="(item, index) in day_sign_fee" :key="index">
                                        <div class="jt-input">
                                            <span>签约天数:</span>
                                            <el-input v-model="item.d" style="width: 80px; margin-left: 10px"> </el-input>
                                        </div>
                                        <div class="jt-input">
                                            <span>预付保险费（单）:</span>
                                            <el-input v-model="item.f" style="width: 80px; margin-left: 10px"> </el-input>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </div> -->
                        <!--  兼职签约自然月 -->
                        <div v-if="submit_data.pay_type == 2">
                            <div class="day-fee">
                                <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' : submit_data.job_type == 2 ? '兼职' : '按单' }}司机包月费</span>
                                <el-input
                                    v-model="submit_data.platform_service_fee"
                                    :placeholder="submit_rules.platform_service_fee.placeholder"
                                    class="input-style"
                                >
                                </el-input
                                >元
                            </el-form-item>
                            <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' : submit_data.job_type == 2 ? '兼职' : '按单' }}天费</span>
                                <el-input v-model="submit_data.day_fee" :placeholder="submit_rules.day_fee.placeholder" class="input-style">
                                </el-input
                                >元
                            </el-form-item>
                            </div>

                            <el-form-item>
                                <!-- 加减号按钮 阶段缴费 -->
                                <div class="jt-border">
                                    <div>
                                        <span class="jd-span">阶段缴费：</span>
                                        <!-- 加减号按钮 -->
                                        <div class="jia-jian-btn">
                                            <el-button
                                                @click="addKiloTake(2)"
                                                type="success"
                                                class="jia-jian-btn1"
                                                icon="el-icon-plus"
                                            ></el-button>

                                            <el-button
                                                @click="subKiloTake(2)"
                                                type="danger"
                                                class="jia-jian-btn1"
                                                icon="el-icon-minus"
                                            ></el-button>
                                        </div>
                                    </div>
                                    <!-- 兼职自然月阶段缴费 -->
                                    <div class="driver-naturl" v-for="(item, index) in natural_month_fee" :key="index">
                                        <div class="jt-input">
                                            <span>每月:</span>
                                            <el-input v-model="item.s" class = "jt-input-val"></el-input> 日
                                        </div>
                                        <div class="jt-input">
                                            <span>到:</span>
                                            <el-input v-model="item.e" class = "jt-input-val"></el-input> 日
                                        </div>
                                        <div class="jt-input">
                                            <span>缴纳:</span>
                                            <el-input v-model="item.f" class = "jt-input-val"></el-input> 元
                                        </div>
                                    </div>
                                    <div class = "jt-desc">不管每月最后一天是几号，填写31即为月末</div>
                                </div>
                            </el-form-item>
                            <el-form-item label="" label-width="10px" class="desc">
                                <div style="font-weight: 700">签约规则:</div>
                                <div>1.以自然月为单位，每个月第一天为签约第一天，月底最后一天签约结束</div>
                                <div>2.可配置多个时间段的签约金额，如约配置到月底，填写31，参考示例图中最后一行 配置</div>
                                <div>3.未配置到月底的时间段部分按最后配置日期至月底的剩余天数*天费计算包月签约金额</div>
                                <div>4.不足整月按签约日至月底的天数*天费进行收取</div>
                                <div>5.若配置阶段缴费，则先取阶段缴费配置进行收费，未配置的日期部分按天费计算收取</div>
                                <div>
                                    <img src="../../../../assets/img/examples.png" alt="" />
                                </div>
                            </el-form-item>
                        </div>
                    </div>


                    <!-- 按单签约缴费方式 -->
                    <div v-if="submit_data.job_type == 3">
                        <el-form-item label="缴费方式:" label-width="120px">
                            <el-radio-group v-model="submit_data.pay_type">
                                <el-radio label="2">自然月签约</el-radio>
                     
                            </el-radio-group>
                        </el-form-item>
                        
                        <!--  按单签约自然月 -->
                        <div v-if="submit_data.pay_type == 2">
                            <div class="day-fee">
                                <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' :submit_data.job_type == 2 ? '兼职' : '按单' }}司机包月费</span>
                                <el-input
                                    v-model="submit_data.platform_service_fee"
                                    :placeholder="submit_rules.platform_service_fee.placeholder"
                                    class="input-style"
                                >
                                </el-input
                                >元
                            </el-form-item>
                            <el-form-item label="" label-width="10px">
                                <span class="driver-sign-title">{{ submit_data.job_type == 1 ? '全职' :submit_data.job_type == 2 ? '兼职' : '按单' }}天费</span>
                                <el-input v-model="submit_data.day_fee" :placeholder="submit_rules.day_fee.placeholder" class="input-style">
                                </el-input
                                >元
                            </el-form-item>
                            </div>

                            <el-form-item>
                                <!-- 加减号按钮 阶段缴费 -->
                                <div class="jt-border">
                                    <div>
                                        <span class="jd-span">阶段缴费：</span>
                                        <!-- 加减号按钮 -->
                                        <div class="jia-jian-btn">
                                            <el-button
                                                @click="addKiloTake(3)"
                                                type="success"
                                                class="jia-jian-btn1"
                                                icon="el-icon-plus"
                                            ></el-button>

                                            <el-button
                                                @click="subKiloTake(3)"
                                                type="danger"
                                                class="jia-jian-btn1"
                                                icon="el-icon-minus"
                                            ></el-button>
                                        </div>
                                    </div>
                                    <!-- 按单自然月阶段缴费 -->
                                    <div class="driver-naturl" v-for="(item, index) in natural_month_fee" :key="index">
                                        <div class="jt-input">
                                            <span>每月:</span>
                                            <el-input v-model="item.s" class = "jt-input-val"></el-input> 日
                                        </div>
                                        <div class="jt-input">
                                            <span>到:</span>
                                            <el-input v-model="item.e" class = "jt-input-val"></el-input> 日
                                        </div>
                                        <div class="jt-input">
                                            <span>缴纳:</span>
                                            <el-input v-model="item.f" class = "jt-input-val"></el-input> 元
                                        </div>
                                    </div>
                                    <div class = "jt-desc">不管每月最后一天是几号，填写31即为月末</div>
                                </div>
                            </el-form-item>
                            <el-form-item label="" label-width="10px" class="desc">
                                <div style="font-weight: 700">签约规则:</div>
                                <div>1.以自然月为单位，每个月第一天为签约第一天，月底最后一天签约结束</div>
                                <div>2.可配置多个时间段的签约金额，如约配置到月底，填写31，参考示例图中最后一行 配置</div>
                                <div>3.未配置到月底的时间段部分按最后配置日期至月底的剩余天数*天费计算包月签约金额</div>
                                <div>4.不足整月按签约日至月底的天数*天费进行收取</div>
                                <div>5.若配置阶段缴费，则先取阶段缴费配置进行收费，未配置的日期部分按天费计算收取</div>
                                <div>
                                    <img src="../../../../assets/img/examples.png" alt="" />
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="true"
                        @toJSON="toJSON"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.submit_data.job_type = _this.data; //把列表 编辑组件的:data="job_type"传递过来赋值给_this.submit_data.job_type，通过这个值判断编辑页面应该显示全职/兼职

            // 请求详情接口
            _this.getDriverSignRuleDetail();
        }
    },
    data() {
        return {
            natural_month_fee: [],
            day_sign_fee: [],
            show: false,
            submit_url: '/driversign/setDriverSignRule',

            // 编辑页面表单数据
            submit_data: {
                job_type: '', //职业类型（1 全职 2 兼职）
                pay_type: '', //缴费类型(1、整月 2、自然月 3、按天)
                platform_service_fee: '', //司机包月费
                day_fee: '', //天费
                natural_month_fee: '', //自然月阶段缴费
                day_sign_fee: '', //按天签约保险费用
                driver_insurance_fee: '' //预付保险费用
            },
            // 编辑页面表单验证规则
            submit_rules: {
                job_type: {
                    placeholder: '工作类型',
                    rules: {
                        required: false,
                        message: '工作类型为不小于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                pay_type: {
                    placeholder: '缴费类型(1、整月 2、自然月 3、按天)',
                    rules: {
                        required: false,
                        message: '缴费类型(1、整月 2、自然月 3、按天)为不小于0的数字',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                platform_service_fee: {
                    placeholder: '司机包月费',
                    rules: {
                        required: false,
                        message: '司机包月费为不小于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                day_fee: {
                    placeholder: '天费',
                    rules: {
                        required: false,
                        message: '天费为不小于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                natural_month_fee: {
                    placeholder: '自然月阶段缴费',
                    rules: {
                        required: false,
                        message: '自然月阶段缴费为不小于0的数字',
                        regulation: 'json_number',
                        rulesData: 0
                    }
                },
                day_sign_fee: {
                    placeholder: '按天签约保险费用',
                    rules: {
                        required: false,
                        message: '按天签约保险费用为不小于0的数字',
                        regulation: 'json_number',
                        rulesData: 0
                    }
                },
                driver_insurance_fee: {
                    placeholder: '预付保险费用',
                    rules: {
                        required: false,
                        message: '预付保险费用为不小于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                }
            },

            search_data_children: {
                job_type: '',
                page: 1,
                limit: 10
            },
            result_data_children: []
        };
    },
    created() {
        _this = this;
    },
    methods: {
        isJobType(pay_type, job_type) {
            console.log(pay_type, 'pay_type----');
            console.log(job_type, 'job_type==========');
            if (pay_type == 1 && job_type == 1) {
                //全职整月

                // 编辑页面表单验证规则
                _this.submit_rules = {
                    job_type: {
                        placeholder: '工作类型',
                        rules: {
                            required: false,
                            message: '工作类型为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    pay_type: {
                        placeholder: '缴费类型(1、整月 2、自然月 3、按天)',
                        rules: {
                            required: false,
                            message: '缴费类型(1、整月 2、自然月 3、按天)为不小于0的数字',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }
                    },
                    platform_service_fee: {
                        placeholder: '司机包月费',
                        rules: {
                            required: true,
                            message: '司机包月费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    day_fee: {
                        placeholder: '天费',
                        rules: {
                            required: false,
                            message: '天费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    natural_month_fee: {
                        placeholder: '自然月阶段缴费',
                        rules: {
                            required: false,
                            message: '自然月阶段缴费为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    day_sign_fee: {
                        placeholder: '按天签约保险费用',
                        rules: {
                            required: false,
                            message: '按天签约保险费用为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    driver_insurance_fee: {
                        placeholder: '预付保险费用',
                        rules: {
                            required: false,
                            message: '预付保险费用为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    }
                };
            } else if (pay_type == 2 && job_type == 1) {
                //全职自然月

                // 编辑页面表单验证规则
                _this.submit_rules = {
                    job_type: {
                        placeholder: '工作类型',
                        rules: {
                            required: false,
                            message: '工作类型为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    pay_type: {
                        placeholder: '缴费类型(1、整月 2、自然月 3、按天)',
                        rules: {
                            required: false,
                            message: '缴费类型(1、整月 2、自然月 3、按天)为不小于0的数字',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }
                    },
                    platform_service_fee: {
                        placeholder: '司机包月费',
                        rules: {
                            required: true,
                            message: '司机包月费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    day_fee: {
                        placeholder: '天费',
                        rules: {
                            required: true,
                            message: '天费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    natural_month_fee: {
                        placeholder: '自然月阶段缴费',
                        rules: {
                            required: false,
                            message: '自然月阶段缴费为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    day_sign_fee: {
                        placeholder: '按天签约保险费用',
                        rules: {
                            required: false,
                            message: '按天签约保险费用为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    driver_insurance_fee: {
                        placeholder: '预付保险费用',
                        rules: {
                            required: false,
                            message: '预付保险费用为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    }
                };
            } else if (pay_type == 2 && job_type == 2) {
                //兼职自然月

                // 编辑页面表单验证规则
                _this.submit_rules = {
                    job_type: {
                        placeholder: '工作类型',
                        rules: {
                            required: false,
                            message: '工作类型为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    pay_type: {
                        placeholder: '缴费类型(1、整月 2、自然月 3、按天)',
                        rules: {
                            required: false,
                            message: '缴费类型(1、整月 2、自然月 3、按天)为不小于0的数字',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }
                    },
                    platform_service_fee: {
                        placeholder: '司机包月费',
                        rules: {
                            required: true,
                            message: '司机包月费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    day_fee: {
                        placeholder: '天费',
                        rules: {
                            required: true,
                            message: '天费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    natural_month_fee: {
                        placeholder: '自然月阶段缴费',
                        rules: {
                            required: false,
                            message: '自然月阶段缴费为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    day_sign_fee: {
                        placeholder: '按天签约保险费用',
                        rules: {
                            required: false,
                            message: '按天签约保险费用为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    driver_insurance_fee: {
                        placeholder: '预付保险费用',
                        rules: {
                            required: false,
                            message: '预付保险费用为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    }
                };
            } else if (pay_type == 3 && job_type == 2) {
                //兼职按天

                // 编辑页面表单验证规则
                _this.submit_rules = {
                    job_type: {
                        placeholder: '工作类型',
                        rules: {
                            required: false,
                            message: '工作类型为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    pay_type: {
                        placeholder: '缴费类型(1、整月 2、自然月 3、按天)',
                        rules: {
                            required: false,
                            message: '缴费类型(1、整月 2、自然月 3、按天)为不小于0的数字',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }
                    },
                    platform_service_fee: {
                        placeholder: '司机包月费',
                        rules: {
                            required: false,
                            message: '司机包月费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    day_fee: {
                        placeholder: '天费',
                        rules: {
                            required: true,
                            message: '天费为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    },
                    natural_month_fee: {
                        placeholder: '自然月阶段缴费',
                        rules: {
                            required: false,
                            message: '自然月阶段缴费为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    day_sign_fee: {
                        placeholder: '按天签约保险费用',
                        rules: {
                            required: false,
                            message: '按天签约保险费用为不小于0的数字',
                            regulation: 'json_number',
                            rulesData: 0
                        }
                    },
                    driver_insurance_fee: {
                        placeholder: '预付保险费用',
                        rules: {
                            required: true,
                            message: '预付保险费用为不小于0的数字',
                            regulation: 'number',
                            rulesData: 0
                        }
                    }
                };
            }
        },

        addKiloTake(e) {
            if (e == 1) {
                //e=1 兼职按天 e=2 自然月
                _this.day_sign_fee.push({ d: '', f: '' });
            } else {
                _this.natural_month_fee.push({ s: '', e: '', f: '' });
            }
        },
        subKiloTake(e) {
            if (e == 1) {
                _this.day_sign_fee.pop();
            } else {
                _this.natural_month_fee.pop();
            }
        },
        //详情
        getDriverSignRuleDetail() {
            _this
                .$post('/driversign/getDriverSignRuleDetail', {
                    job_type: _this.submit_data.job_type
                })
                .then((res) => {
                    console.log(_this.submit_data.pay_type, '_this.pay_type');

                    _this.submit_data.pay_type = res.data.pay_type;
                    _this.submit_data.platform_service_fee = res.data.platform_service_fee;
                    _this.submit_data.day_fee = res.data.day_fee;

                    if (res.data.natural_month_fee == '') {
                        //如果接口返回的值是空字符串，不转数组会导致加号按钮点击没反应，所以我们把空字符串转成空数组，因为添加按钮addKiloTake方法的时候需要调用空数组里面push，字符串不能用push方法，但是数组可以
                        _this.natural_month_fee = [];
                    } else {
                        _this.natural_month_fee = res.data.natural_month_fee;
                    }
                    if (res.data.day_sign_fee == '') {
                        _this.day_sign_fee = [];
                    } else {
                        _this.day_sign_fee = res.data.day_sign_fee;
                    }

                    _this.submit_data.driver_insurance_fee = res.data.driver_insurance_fee;

                    _this.isJobType(_this.submit_data.pay_type, _this.submit_data.job_type); //全职整月，全职/兼职自然月，兼职按天 页面的输入项是不一致的，所以验证规则也不一样，这个方法就是根据不同页面动态改变验证规则
                })
                .catch((err) => {});
        },
        setDriverSignRule() {
            _this
                .$post(driversign / setDriverSignRule, _this.search_data_children)
                .then((res) => {
                    _this.result_data_children = res;

                    _this.grabbingData = res.data;
                })
                .catch((err) => {});
        },
        toJSON() {
            _this.isJobType(_this.submit_data.pay_type, _this.submit_data.job_type); //提交数据之前验证一下提交数据规则
            if (_this.natural_month_fee.length != 0) {
                _this.submit_data.natural_month_fee = JSON.stringify(_this.natural_month_fee);
            }
            if (_this.day_sign_fee.length != 0) {
                _this.submit_data.day_sign_fee = JSON.stringify(_this.day_sign_fee);
            }

            if (_this.submit_data.pay_type == 1 && _this.submit_data.job_type == 1) {
                //全职整月 如果编辑页面切换缴费方式，比如切换到整月，就应该把自然月数据清空，如果切换到自然月，就应该把整月下的输入框清空
                _this.submit_data.day_fee = ''; //天费
                _this.submit_data.natural_month_fee = ''; //自然月阶段缴费
                _this.natural_month_fee = []; //自然月阶段缴费
            } else if (_this.submit_data.pay_type == 2 && _this.submit_data.job_type == 1) {
                //全职自然月 自然月和整月里面的司机包月费绑定的是一个值，所以提交的时候不能清空
            } else if (_this.submit_data.pay_type == 2 && _this.submit_data.job_type == 2) {
                //兼职自然月

                _this.submit_data.driver_insurance_fee = ''; //预付保险费用
                _this.submit_data.day_sign_fee = ''; //按天阶段缴费
                _this.day_sign_fee = []; //按天阶段缴费
            } else if (_this.submit_data.pay_type == 3 && _this.submit_data.job_type == 2) {
                //兼职按天 兼职自然月和兼职按天 兼职天费绑定的是同一个值所以提交的时候不能清空
                _this.submit_data.platform_service_fee = ''; //司机包月费

                _this.submit_data.natural_month_fee = ''; //自然月阶段缴费
                _this.natural_month_fee = []; //自然月阶段缴费
            }
            console.log(_this.submit_data);
        },
        // 提交
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.submit_data = {
                job_type: '',
                pay_type: '',
                platform_service_fee: '',
                day_fee: '',
                natural_month_fee: '',
                day_sign_fee: '',
                driver_insurance_fee: ''
            };
            _this.natural_month_fee = [];
            _this.day_sign_fee = [];
        }
    }
};
</script>

<style scoped>
#container_route {
    height: 137px;
    height: 100%;
    width: 50%;
}

.steps {
    box-sizing: border-box;
    padding: 20px 50px 0;
    box-sizing: border-box;
    font-size: 12px;
    margin-bottom: 20px;
}

.box {
    height: calc(100vh - 350px);
    margin-left: 20px;
    display: flex;
    justify-content: space-around;
}

.tabs-item {
    margin-top: 20px;
}

.tabs-item div {
    margin: 20px 0;
}

.tabs-item div span {
    font-size: 16px;
    font-weight: 400;
}

.tabs-box {
    width: 50%;
    padding: 0 16px;
    height: calc(100vh - 350px);
}
</style>
<style>
.iconfont.icon-zihangche {
    font-size: 60px !important;
}

.iconfont.icon-zihangche::before {
    color: #00b9da !important;
}

.tabs-box .tabs {
    height: 100%;
}

.tabs-box .el-tabs__content {
    height: 90%;
    overflow: auto;
}

.order-detial-wrap #el-drawer__title > span {
    font-size: 18px;
    font-family: 'Microsoft YaHei';
    font-weight: 600;
    color: #222;
    line-height: 21px;
}

.order-detial-wrap .el-tabs--card > .el-tabs__header {
    border-bottom: 1px solid #e4e7ed !important;
}

.order-detial-wrap .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #fff !important;
    border-left: 1px solid rgb(228, 231, 237) !important;
    border-right: 1px solid rgb(228, 231, 237) !important;
    border-top: 1px solid rgb(228, 231, 237) !important;
}

.order-detial-wrap .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-bottom: 1px solid transparent;
}

.primary-table {
    margin-top: 40px;
    padding: 10px;
}

.primary-table,
.primary-table th,
.primary-table td {
    border: none;
}

.primary-table tr {
    border: 1px solid #ccc;
    transition: 0.5s;
}

.primary-table td {
    font-size: 12px;
    color: #333;
    padding: 10px;
}
.desc {
    color: #606266;
    margin-left: 40px;
}

.even td,
.Odd td {
    font-size: 14px;
    font-weight: 400;
}

.even {
    background-color: #f5f7fa;
}

.head {
    background-color: #eff2f7;
}

.primary-table tr:hover {
    background-color: #b4d2f4;
}
.form-box {
    width: 1000px;
}
.jd-span {
    color: #606266;
    margin-right: 460px;
}
.form-box .driver-sign-form {
    color: #606266 !important;
}
.driver-sign-title {
    margin: 20px 40px;
}
.input-style {
    width: 150px;
    margin-right: 5px;
}
.jt-border {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-top: 20px;
    border: 1px solid #efefef;
    margin-bottom: 10px;
}
.driver-sign-form .el-form-item__content {
    margin-left: 50px !important;
    width: 700px;
}
.jia-jian-btn {
    display: inline-block;
    margin-bottom: 20px;
}
.jia-jian-btn1 {
    width: 50px;
    height: 40px;
}
.driver-naturl {
    display: flex;
    justify-content: center;
    color: #606266;
}
.jt-input {
    margin: 10px 20px;
}
.jt-input-val {
    width: 60px;
    margin-left: 10px;
}
.jt-desc {
    margin-left: 380px;
    color: red;
}
.day-fee {
    display:inline-block;
    margin-left:-40px;
}

</style>
